import { z } from 'zod';
import { EnumUtils } from '@colonist/utils';
import { createKeyRecordSchema } from './KeyRecordSchemas.ts';
export var VictoryPointType = /*#__PURE__*/ function(VictoryPointType) {
    VictoryPointType[VictoryPointType["Settlement"] = 0] = "Settlement";
    VictoryPointType[VictoryPointType["City"] = 1] = "City";
    VictoryPointType[VictoryPointType["DevelopmentCardVictoryPoint"] = 2] = "DevelopmentCardVictoryPoint";
    VictoryPointType[VictoryPointType["LargestArmy"] = 3] = "LargestArmy";
    VictoryPointType[VictoryPointType["LongestRoad"] = 4] = "LongestRoad";
    VictoryPointType[VictoryPointType["Chits"] = 5] = "Chits";
    VictoryPointType[VictoryPointType["Metropolis"] = 6] = "Metropolis";
    VictoryPointType[VictoryPointType["DefenderOfColonist"] = 7] = "DefenderOfColonist";
    VictoryPointType[VictoryPointType["ProgressCardVictoryPoint"] = 8] = "ProgressCardVictoryPoint";
    VictoryPointType[VictoryPointType["Merchant"] = 9] = "Merchant";
    return VictoryPointType;
}({});
const victoryPointTypeKeys = EnumUtils.getEnumValues(VictoryPointType);
export const victoryPointStateSchema = createKeyRecordSchema(victoryPointTypeKeys, z.number().int().nonnegative());
